import  { useEffect, useState } from "react";
import qs from "qs";
import { useParams } from "react-router-dom";
import { socketFunc } from "../../../../utils/socketUtil";
import { Toaster } from "../../../../utils/toaster";
import AppIframe from "../../../components/AppIframe";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { useSelector } from "react-redux";
import {
  AppTheme,
  PublicIgPixelUrl,
  SportsLobbyProviders,
} from "../../../../config/const";
import Header from "../../../../containers/Header";

const DynamicGames = ({ isSubSection = false, customProvider = null }) => {
  const { provider: pd } = useParams();
  const { isAuth, token } = useSelector((state) => state.auth);
  const provider = customProvider || pd;
  const socket = socketFunc(token);
  const [iframeUrl, setIframeUrl] = useState("");
  const { appTheme } = useSelector((state) => state.app);

  useEffect(() => {
    const decodedParams = decodeURIComponent(window.location.href);
    const parsedValues = qs.parse(decodedParams.split("?")?.[1] || "");
    getLobby(parsedValues);
  }, [provider, isAuth, appTheme]);

  const getThemeForPublicUrl = (iframeUrl) => {
   
    const currentUrlTheme =
      iframeUrl?.indexOf("mode=light&primaryColor=#00ff00") > -1
        ? AppTheme.Light
        : iframeUrl?.indexOf("mode=dark&primaryColor=#00ff00") > -1
          ? AppTheme.Dark
          : "";

    let url = iframeUrl;
    if (!currentUrlTheme) {
      url = url + `?mode=${appTheme}`;
    } else {
      url = url?.replace(currentUrlTheme, appTheme);
    }
    return url;
  };

  const getLobby = (params) => {
    if (!isAuth) {
       
      if (provider === SportsLobbyProviders.IgPixel) {
      
        const slugedUrl = `${PublicIgPixelUrl}/${params?.slug}`;
        setIframeUrl(`${getThemeForPublicUrl(slugedUrl)}`);
      }
      return;
    }

    let payload = { ...params };
    payload.providerCode = provider?.toUpperCase();
    payload.theme = appTheme;
    if (provider?.toLowerCase() === "ig_pixel") {
      
    }
    socket.emit("get:sports_lobby", payload, (res) => {
      if (res?.status === "failed") {
        Toaster.Error(res?.message || "Failed to get");
      }
      if (res?.status === "success") {
        handleResponse(res);
      }
    });
  };

  const handleResponse = (value) => {
    if (value?.data && typeof value?.data === "string") {
      setIframeUrl(value?.data);
    } else if (value?.data && "lobbyUrl" in value?.data?.data) {
      setIframeUrl(value?.data?.data?.lobbyUrl);
    } else {
      setIframeUrl("");
    }
  };

  return (
    <div className="live_casino_page live">
      {/* {!isSubSection && <>{isAuth ? <HeaderAfterLogin /> : <Header />}</>} */}
      <AppIframe
        iframeUrl={iframeUrl}
        isRedirectionRequired={false}
        style={{
          width: "100%",
          height: "calc(100vh - 73px)",
        }}
      />

      
    </div>
  );
};
export default DynamicGames;
